
import {computed, defineComponent, toRef} from "vue";

interface Props {
  label: string;
  required: boolean;
  disabled: boolean;
  for: string | null;
  size: string | null;
}

export default defineComponent({
  props: {
    label: {
      type: String,
      required: false,
      default: () => "",
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    for: {
      type: String,
      required: false,
      default: null,
    },
    size: {
      type: String,
      required: false,
      default: "sm",
    },
  },
  setup(props: Props) {
    const labelFor = toRef(props, "for");

    /* const tagType = watch(id, () => {
      return Boolean(id.value) ? "label" : "div";
    }); */

    const tagType = computed(() => {
      return Boolean(labelFor.value) ? "label" : "div";
    });

    return {labelFor, tagType};
  },
});
